// extracted by mini-css-extract-plugin
export var table = "_xn-0";